import React from "react";

import { Icon, IconProps } from "../";

export const SearchSeeIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.30653 5.30653C6.78338 3.82969 8.78642 3 10.875 3C12.9636 3 14.9666 3.82969 16.4435 5.30653C17.9203 6.78338 18.75 8.78642 18.75 10.875C18.75 12.7121 18.1081 14.483 16.9485 15.8878L20.0303 18.9697C20.3232 19.2626 20.3232 19.7374 20.0303 20.0303C19.7374 20.3232 19.2626 20.3232 18.9697 20.0303L15.8878 16.9485C14.483 18.1081 12.7121 18.75 10.875 18.75C8.78642 18.75 6.78338 17.9203 5.30653 16.4435C3.82969 14.9666 3 12.9636 3 10.875C3 8.78642 3.82969 6.78338 5.30653 5.30653ZM10.875 4.5C9.18425 4.5 7.56274 5.17165 6.36719 6.36719C5.17165 7.56274 4.5 9.18425 4.5 10.875C4.5 12.5658 5.17165 14.1873 6.36719 15.3828C7.56274 16.5784 9.18425 17.25 10.875 17.25C12.5658 17.25 14.1873 16.5784 15.3828 15.3828C16.5784 14.1873 17.25 12.5658 17.25 10.875C17.25 9.18425 16.5784 7.56274 15.3828 6.36719C14.1873 5.17165 12.5658 4.5 10.875 4.5ZM10.875 15.125C13.2222 15.125 15.125 13.2222 15.125 10.875C15.125 8.52779 13.2222 6.625 10.875 6.625C8.52779 6.625 6.625 8.52779 6.625 10.875C6.625 13.2222 8.52779 15.125 10.875 15.125Z"
      />
    </Icon>
  );
};
